import { StyledFooter } from "./style"
import IconComponent from "themes/IconComponent"

const LocalizationFooter = () => {
	return (
        <StyledFooter>
            <IconComponent asset="/icons/footerDecoration.svg" height="1.25rem" />
        </StyledFooter>
	)
}

export default LocalizationFooter

